export enum ValidationTypesEnum {
  REQUIRED = 'required',
  EMAIL = 'email',
  TEXT_LENGTH = 'textLength',
}
